import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-end" }
const _hoisted_2 = { class: "divide-y divide-gray-200" }
const _hoisted_3 = { class: "whitespace-nowrap" }
const _hoisted_4 = { class: "truncate" }
const _hoisted_5 = { class: "flex justify-end" }
const _hoisted_6 = {
  key: 0,
  class: "mt-2 text-sm text-amber-700"
}
const _hoisted_7 = { class: "rounded bg-gray-900 px-3 py-2 text-center text-sm text-white" }
const _hoisted_8 = {
  key: 2,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_9 = { class: "flex items-center gap-2 mb-4" }
const _hoisted_10 = { class: "inline-flex items-center whitespace-nowrap rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-800" }
const _hoisted_11 = { class: "rounded bg-gray-900 px-3 py-2 text-center text-sm text-white" }
const _hoisted_12 = { class: "py-2" }

import { XCircleIcon } from '@heroicons/vue/24/outline'
import { computed, onMounted, ref, watch } from 'vue'

import EmptyState from '@/components/neue/EmptyState'
import FormElement from '@/components/neue/FormElement'
import FormSection from '@/components/neue/FormSection'
import ImageUploaderNeue from '@/components/neue/ImageUploaderNeue'
import InputArea from '@/components/neue/InputArea'
import InputField from '@/components/neue/InputField'
import NeueButton from '@/components/neue/NeueButton'
import NeueTablist from '@/components/neue/NeueTablist'
import NeueToggle from '@/components/neue/NeueToggle'
import PopupCard from '@/components/neue/PopupCard'
import SelectInput from '@/components/neue/SelectInput'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import TablistHeader from '@/components/neue/TablistHeader'
import TablistRow from '@/components/neue/TablistRow'
import TheModal from '@/components/TheModal'
import api from '@/store/api'
import { mapRelationships, mapType } from '@/store/mappers'

const pagesGetUrl =
  'pages?included=page_modules,page_modules.content_elements,page_modules.content_elements.attachments,page_modules.popup,page_modules.banner'


export default {
  __name: 'StorePopups',
  props: ['id'],
  setup(__props) {

const props = __props

const loading = ref(true)
const modal = ref({ open: false })
const showPreview = ref(false)
const pendingImage = ref(null) // attachment object for popup add flow
const discountCodes = ref([])

const AUDIENCE_LABELS = {
  all: 'All customers',
  first_time: 'First time customers',
  returning: 'Returning customers'
}

const AUDIENCE_OPTIONS = [
  { name: 'All customers', value: 'all' },
  { name: 'First time customers', value: 'first_time' },
  { name: 'Returning customers', value: 'returning' }
]

const audienceLabel = audience => AUDIENCE_LABELS[audience] || audience

const popupPage = computed(() =>
  mapType('page').find(x => x.attributes.type === 'PopupPage' && x.attributes.store_id === parseInt(props.id, 10))
)

const bannerPage = computed(() =>
  mapType('page').find(x => x.attributes.type === 'BannerPage' && x.attributes.store_id === parseInt(props.id, 10))
)

const announcements = computed(() => {
  const popupRows = !popupPage.value
    ? []
    : mapRelationships(popupPage.value.relationships.page_modules?.data).map(mod => {
        const ce = mapRelationships(mod.relationships.content_elements?.data)
        const headlineCe = ce.find(
          el => el.attributes.type === 'TextContentElement' && el.attributes.purpose === 'headline'
        )
        const bodyCe = ce.find(el => el.attributes.type === 'TextContentElement' && el.attributes.purpose === 'body')
        const imageCe = ce.find(el => el.attributes.type === 'AttachmentContentElement')
        const popupRel = mod.relationships.popup?.data
        const popup = popupRel ? mapRelationships([popupRel])[0] : null
        const images = imageCe ? mapRelationships(imageCe.relationships.attachments?.data) : []
        return {
          type: 'popup',
          moduleId: mod.id,
          popupId: popup?.id ?? null,
          headlineCeId: headlineCe?.id ?? null,
          bodyCeId: bodyCe?.id ?? null,
          imageCeId: imageCe?.id ?? null,
          audience: popup?.attributes?.audience ?? null,
          headline: headlineCe?.attributes?.primary_text ?? '',
          body: bodyCe?.attributes?.primary_text ?? '',
          collectFromCustomer: popup?.attributes?.collect_from_customer ?? 'none',
          giveReward: popup?.attributes?.give_reward ?? false,
          discountCodeId: popup?.attributes?.discount_code_id ?? null,
          images,
          enabled: !!mod.attributes.visible
        }
      })

  const bannerRows = !bannerPage.value
    ? []
    : mapRelationships(bannerPage.value.relationships.page_modules?.data).map(mod => {
        const ce = mapRelationships(mod.relationships.content_elements?.data)
        const textCe = ce.find(el => el.attributes.type === 'TextContentElement' && el.attributes.purpose === 'text')
        const bannerRel = mod.relationships.banner?.data
        const banner = bannerRel ? mapRelationships([bannerRel])[0] : null
        return {
          type: 'banner',
          moduleId: mod.id,
          bannerId: banner?.id,
          textCeId: textCe?.id,
          audience: banner?.attributes?.audience,
          text: textCe?.attributes?.primary_text || '',
          enabled: !!mod.attributes.visible
        }
      })

  return [...popupRows, ...bannerRows]
})

const usedAudiencesFor = type => announcements.value.filter(a => a.type === type).map(a => a.audience)

const availableAudienceOptions = computed(() => {
  if (!modal.value.type) return []
  const used = usedAudiencesFor(modal.value.type)
  return AUDIENCE_OPTIONS.filter(opt => !used.includes(opt.value))
})

const allAudiencesUsedForType = computed(() => modal.value.type && availableAudienceOptions.value.length === 0)

watch(
  () => modal.value.type,
  () => {
    if (modal.value.mode === 'add') {
      modal.value.audience = null
    }
  }
)

const canSaveModal = computed(() => {
  if (modal.value.mode === 'add') {
    if (!modal.value.type || !modal.value.audience) return false
    if (modal.value.type === 'banner') return !!modal.value.text
    if (modal.value.type === 'popup') return !!modal.value.headline
    return false
  }
  if (modal.value.mode === 'edit') {
    if (modal.value.type === 'popup') return !!modal.value.headline
    if (modal.value.type === 'banner') return !!modal.value.text
  }
  return false
})

const discountCodeOptions = computed(() =>
  discountCodes.value.map(c => ({
    name: c.attributes.discount_code_name || c.attributes.code,
    value: parseInt(c.id, 10)
  }))
)

const fetchPages = () => api.call('GET', pagesGetUrl)

onMounted(async () => {
  await Promise.all([fetchPages(), api.call('GET', 'discount_codes?included=none')])
  discountCodes.value = mapType('discount_code')
  loading.value = false
})

const openAddAnnouncement = () => {
  modal.value = {
    open: true,
    mode: 'add',
    type: null,
    audience: null,
    enabled: true,
    duplicateError: false,
    headline: '',
    text: '',
    collectFromCustomer: 'none',
    giveReward: false,
    discountCodeId: null
  }
  pendingImage.value = null
}

const openEditAnnouncement = row => {
  if (row.type === 'popup') {
    modal.value = {
      open: true,
      mode: 'edit',
      type: 'popup',
      moduleId: row.moduleId,
      popupId: row.popupId,
      headlineCeId: row.headlineCeId,
      bodyCeId: row.bodyCeId,
      imageCeId: row.imageCeId,
      audience: row.audience,
      headline: row.headline,
      text: row.body,
      collectFromCustomer: row.collectFromCustomer,
      giveReward: row.giveReward,
      discountCodeId: row.discountCodeId,
      images: row.images,
      enabled: row.enabled
    }
  } else {
    modal.value = {
      open: true,
      mode: 'edit',
      type: 'banner',
      moduleId: row.moduleId,
      bannerId: row.bannerId,
      textCeId: row.textCeId,
      audience: row.audience,
      text: row.text,
      enabled: row.enabled
    }
  }
}

// For Add mode: ImageUploaderNeue uploads the file to upload_attachments immediately and
// commits the attachment to the store, then emits { _id }. We hold that attachment id
// locally until Save, then link it to the imageCeId after the module is created.
const addModeImageFiles = computed(() => (pendingImage.value ? [pendingImage.value] : []))

const onPendingImageChange = payload => {
  // payload is either [{ _id, order }] (add) or [{ id, _destroy: true }] (remove) per ImageUploaderNeue
  if (Array.isArray(payload) && payload.length && payload[0]._destroy) {
    pendingImage.value = null
    return
  }
  const entry = Array.isArray(payload) ? payload[0] : payload
  const id = entry?._id
  if (!id) return
  // Pull the attachment object out of the store so :files renders the preview.
  const all = mapType('attachment') || []
  const attachment = all.find(a => String(a.id) === String(id))
  if (attachment) pendingImage.value = attachment
}

const saveAnnouncement = async () => {
  modal.value.duplicateError = false

  if (modal.value.mode === 'add') {
    // Ensure the matching page exists for this store
    if (modal.value.type === 'popup' && !popupPage.value) {
      const res = await api.call('POST', 'pages', {
        page: { type: 'PopupPage', store_id: parseInt(props.id, 10), visible: true }
      })
      if (!res?.data?.data?.id) return
      await fetchPages()
    }
    if (modal.value.type === 'banner' && !bannerPage.value) {
      const res = await api.call('POST', 'pages', {
        page: { type: 'BannerPage', store_id: parseInt(props.id, 10), visible: true }
      })
      if (!res?.data?.data?.id) return
      await fetchPages()
    }

    const pageId = modal.value.type === 'popup' ? popupPage.value.id : bannerPage.value.id
    const moduleType = modal.value.type === 'popup' ? 'PopupPageModule' : 'BannerPageModule'
    const childAttrsKey = modal.value.type === 'popup' ? 'popup_attributes' : 'banner_attributes'

    let createdAudience
    let createdType
    try {
      await api.call('POST', `pages/${pageId}/page_modules`, {
        page_module: { type: moduleType, [childAttrsKey]: { audience: modal.value.audience } }
      })
      createdAudience = modal.value.audience
      createdType = modal.value.type
    } catch (e) {
      if (e?.response?.status === 422) {
        modal.value.duplicateError = true
        return
      }
      throw e
    }

    await fetchPages()
    const newRow = announcements.value.find(a => a.type === createdType && a.audience === createdAudience)
    if (!newRow) {
      modal.value = { open: false }
      return
    }

    // Save the content fields in one PUT (and link the pending image if any).
    if (createdType === 'banner') {
      await api.call('PUT', `pages/${bannerPage.value.id}`, {
        page: {
          page_modules_attributes: [
            {
              id: newRow.moduleId,
              visible: modal.value.enabled,
              content_elements_attributes: [
                {
                  id: newRow.textCeId,
                  type: 'TextContentElement',
                  purpose: 'text',
                  primary_text: modal.value.text
                }
              ]
            }
          ]
        }
      })
    } else {
      const contentEls = [
        { id: newRow.headlineCeId, primary_text: modal.value.headline },
        { id: newRow.bodyCeId, primary_text: modal.value.text }
      ]
      if (pendingImage.value && newRow.imageCeId) {
        contentEls.push({ id: newRow.imageCeId, attachments_attributes: [{ _id: pendingImage.value.id }] })
      }
      await api.call('PUT', `pages/${popupPage.value.id}`, {
        page: {
          page_modules_attributes: [
            {
              id: newRow.moduleId,
              visible: modal.value.enabled,
              content_elements_attributes: contentEls,
              popup_attributes: {
                id: newRow.popupId,
                collect_from_customer: modal.value.collectFromCustomer,
                give_reward: modal.value.giveReward,
                discount_code_id: modal.value.giveReward ? modal.value.discountCodeId : null
              }
            }
          ]
        }
      })
    }

    await fetchPages()
    pendingImage.value = null
    modal.value = { open: false }
    return
  }

  // Edit mode
  if (modal.value.type === 'popup') {
    await api.call('PUT', `pages/${popupPage.value.id}`, {
      page: {
        page_modules_attributes: [
          {
            id: modal.value.moduleId,
            visible: modal.value.enabled,
            content_elements_attributes: [
              { id: modal.value.headlineCeId, primary_text: modal.value.headline },
              { id: modal.value.bodyCeId, primary_text: modal.value.text }
            ],
            popup_attributes: {
              id: modal.value.popupId,
              collect_from_customer: modal.value.collectFromCustomer,
              give_reward: modal.value.giveReward,
              discount_code_id: modal.value.giveReward ? modal.value.discountCodeId : null
            }
          }
        ]
      }
    })
  } else {
    await api.call('PUT', `pages/${bannerPage.value.id}`, {
      page: {
        page_modules_attributes: [
          {
            id: modal.value.moduleId,
            visible: modal.value.enabled,
            content_elements_attributes: [
              {
                id: modal.value.textCeId,
                type: 'TextContentElement',
                purpose: 'text',
                primary_text: modal.value.text
              }
            ]
          }
        ]
      }
    })
  }

  await fetchPages()
  modal.value = { open: false }
}

const deleteAnnouncement = async row => {
  if (!confirm('Delete this announcement?')) return
  const pageId = row.type === 'popup' ? popupPage.value?.id : bannerPage.value?.id
  if (!pageId) return
  await api.call('DELETE', `pages/${pageId}/page_modules/${row.moduleId}`, {}, { delete: false })
  await fetchPages()
}

const toggleEnabled = async (row, val) => {
  const pageId = row.type === 'popup' ? popupPage.value?.id : bannerPage.value?.id
  if (!pageId) return
  await api.call('PUT', `pages/${pageId}`, {
    page: { page_modules_attributes: [{ id: row.moduleId, visible: val }] }
  })
  await fetchPages()
}

const changeImage = async images => {
  if (!popupPage.value || modal.value.type !== 'popup' || !modal.value.imageCeId) return
  await api.call('PUT', `pages/${popupPage.value.id}`, {
    page: {
      page_modules_attributes: [
        {
          id: modal.value.moduleId,
          content_elements_attributes: [{ id: modal.value.imageCeId, attachments_attributes: images }]
        }
      ]
    }
  })
  await fetchPages()
  const refreshed = announcements.value.find(a => a.type === 'popup' && a.moduleId === modal.value.moduleId)
  if (refreshed) {
    modal.value.images = refreshed.images
    modal.value.imageCeId = refreshed.imageCeId
  }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[34] || (_cache[34] = _createElementVNode("div", {
      id: "linkable-announcements",
      class: "scroll-mt-10"
    }, null, -1)),
    _createVNode(_unref(FormSection), {
      name: "Announcements",
      description: "Configure marketing announcements that appear to customers when they visit your store.",
      loading: loading.value,
      fullwidth: true
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(FormElement), null, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_unref(NeueTablist), null, {
              head: _withCtx(() => [
                _createVNode(_unref(TablistHeader), null, {
                  default: _withCtx(() => [
                    _createVNode(TablistGrid, {
                      columns: ['Type', 'Audience', 'Content', 'Enabled', ''],
                      header: "",
                      class: "items-center"
                    }, {
                      default: _withCtx(() => [
                        _cache[23] || (_cache[23] = _createElementVNode("div", null, "Type", -1)),
                        _cache[24] || (_cache[24] = _createElementVNode("div", null, "Audience", -1)),
                        _cache[25] || (_cache[25] = _createElementVNode("div", null, "Content", -1)),
                        _cache[26] || (_cache[26] = _createElementVNode("div", null, "Enabled", -1)),
                        _createElementVNode("div", _hoisted_1, [
                          _createVNode(_unref(NeueButton), {
                            type: "secondary",
                            onClick: openAddAnnouncement
                          }, {
                            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                              _createTextVNode("+ Announcement", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(announcements.value, (row) => {
                    return (_openBlock(), _createBlock(_unref(TablistRow), {
                      key: `${row.type}-${row.moduleId}`,
                      class: "cursor-pointer",
                      onClick: $event => (openEditAnnouncement(row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(TablistGrid, {
                          columns: ['Type', 'Audience', 'Content', 'Enabled', ''],
                          class: "items-center"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium", row.type === 'popup' ? 'bg-blue-100 text-blue-800' : 'bg-gray-900 text-white'])
                              }, _toDisplayString(row.type === 'popup' ? 'Popup' : 'Banner'), 3)
                            ]),
                            _createElementVNode("div", _hoisted_3, _toDisplayString(audienceLabel(row.audience)), 1),
                            _createElementVNode("div", _hoisted_4, _toDisplayString(row.type === 'popup' ? row.headline : row.text), 1),
                            _createElementVNode("div", {
                              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createVNode(_unref(NeueToggle), {
                                "model-value": row.enabled,
                                compact: true,
                                "onUpdate:modelValue": val => toggleEnabled(row, val)
                              }, null, 8, ["model-value", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_unref(XCircleIcon), {
                                class: "h-6 w-6 hover:text-black shrink-0",
                                onClick: _withModifiers($event => (deleteAnnouncement(row)), ["stop"])
                              }, null, 8, ["onClick"])
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 512), [
              [_vShow, announcements.value.length]
            ]),
            (!announcements.value.length)
              ? (_openBlock(), _createBlock(_unref(EmptyState), {
                  key: 0,
                  plural: "announcements",
                  class: "max-w-xl"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NeueButton), {
                      type: "secondary",
                      onClick: openAddAnnouncement
                    }, {
                      default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                        _createTextVNode("+ Announcement", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_unref(TheModal), {
      "is-open": modal.value.open,
      "modal-title": modal.value.mode === 'add' ? 'Add announcement' : 'Edit announcement',
      "max-width": "max-w-xl",
      onCloseModal: _cache[19] || (_cache[19] = $event => (modal.value = { open: false }))
    }, {
      main: _withCtx(() => [
        _createVNode(_unref(FormSection), null, {
          default: _withCtx(() => [
            (modal.value.mode === 'add')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_unref(FormElement), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SelectInput), {
                        modelValue: modal.value.type,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((modal.value.type) = $event)),
                        name: "Type",
                        placeholder: "Choose announcement type",
                        options: [
                { name: 'Popup', value: 'popup' },
                { name: 'Banner', value: 'banner' }
              ]
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (modal.value.type)
                    ? (_openBlock(), _createBlock(_unref(FormElement), { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(SelectInput), {
                            modelValue: modal.value.audience,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((modal.value.audience) = $event)),
                            name: "Audience",
                            placeholder: "Choose audience",
                            options: availableAudienceOptions.value
                          }, null, 8, ["modelValue", "options"]),
                          (allAudiencesUsedForType.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, " All audiences are already used for " + _toDisplayString(modal.value.type === 'popup' ? 'Popups' : 'Banners') + " - pick a different type or delete an existing one. ", 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (modal.value.type && modal.value.audience)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_unref(FormElement), null, {
                          default: _withCtx(() => [
                            _cache[28] || (_cache[28] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Enabled", -1)),
                            _createVNode(_unref(NeueToggle), {
                              modelValue: modal.value.enabled,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((modal.value.enabled) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        (modal.value.type === 'banner')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_unref(FormElement), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(InputArea), {
                                    modelValue: modal.value.text,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((modal.value.text) = $event)),
                                    name: "Text",
                                    placeholder: "Enter the banner text"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(FormElement), null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, _toDisplayString(modal.value.text || 'Banner preview'), 1)
                                ]),
                                _: 1
                              })
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(_unref(FormElement), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(InputField), {
                                    modelValue: modal.value.headline,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((modal.value.headline) = $event)),
                                    name: "Headline",
                                    placeholder: "Enter a headline"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(FormElement), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ImageUploaderNeue), {
                                    files: addModeImageFiles.value,
                                    editable: true,
                                    "display-multiple": false,
                                    "max-file-size": 2 * 1024 * 1024,
                                    onChange: onPendingImageChange
                                  }, null, 8, ["files"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(FormElement), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(InputArea), {
                                    modelValue: modal.value.text,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((modal.value.text) = $event)),
                                    name: "Body text",
                                    placeholder: "Enter the body text"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(FormElement), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(SelectInput), {
                                    modelValue: modal.value.collectFromCustomer,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((modal.value.collectFromCustomer) = $event)),
                                    name: "Collect from customer",
                                    options: [
                    { name: 'None', value: 'none' },
                    { name: 'Contact Number', value: 'contact_number' },
                    { name: 'Email Address', value: 'email_address' }
                  ]
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(FormElement), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NeueToggle), {
                                    modelValue: modal.value.giveReward,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((modal.value.giveReward) = $event)),
                                    name: "Give reward"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              (modal.value.giveReward)
                                ? (_openBlock(), _createBlock(_unref(FormElement), { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(SelectInput), {
                                        modelValue: modal.value.discountCodeId,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((modal.value.discountCodeId) = $event)),
                                        name: "Discount code",
                                        placeholder: "Select a discount code",
                                        options: discountCodeOptions.value
                                      }, null, 8, ["modelValue", "options"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ], 64))
                      ], 64))
                    : _createCommentVNode("", true),
                  (modal.value.duplicateError)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, " An announcement for this audience already exists. "))
                    : _createCommentVNode("", true)
                ], 64))
              : (modal.value.mode === 'edit')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium", modal.value.type === 'popup' ? 'bg-blue-100 text-blue-800' : 'bg-gray-900 text-white'])
                      }, _toDisplayString(modal.value.type === 'popup' ? 'Popup' : 'Banner'), 3),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(audienceLabel(modal.value.audience)), 1)
                    ]),
                    _createVNode(_unref(FormElement), null, {
                      default: _withCtx(() => [
                        _cache[29] || (_cache[29] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Enabled", -1)),
                        _createVNode(_unref(NeueToggle), {
                          modelValue: modal.value.enabled,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((modal.value.enabled) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    (modal.value.type === 'popup')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_unref(FormElement), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(InputField), {
                                modelValue: modal.value.headline,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((modal.value.headline) = $event)),
                                name: "Headline",
                                placeholder: "Enter a headline for your popup"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormElement), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ImageUploaderNeue), {
                                files: modal.value.images,
                                editable: true,
                                "display-multiple": false,
                                "max-file-size": 2 * 1024 * 1024,
                                onChange: changeImage
                              }, null, 8, ["files"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormElement), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(InputArea), {
                                modelValue: modal.value.text,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((modal.value.text) = $event)),
                                name: "Body text",
                                placeholder: "Enter the body text for your popup"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormElement), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(SelectInput), {
                                modelValue: modal.value.collectFromCustomer,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((modal.value.collectFromCustomer) = $event)),
                                name: "Collect from customer",
                                options: [
                  { name: 'None', value: 'none' },
                  { name: 'Contact Number', value: 'contact_number' },
                  { name: 'Email Address', value: 'email_address' }
                ]
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormElement), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NeueToggle), {
                                modelValue: modal.value.giveReward,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((modal.value.giveReward) = $event)),
                                name: "Give reward"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          (modal.value.giveReward)
                            ? (_openBlock(), _createBlock(_unref(FormElement), { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(SelectInput), {
                                    modelValue: modal.value.discountCodeId,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((modal.value.discountCodeId) = $event)),
                                    name: "Discount code",
                                    placeholder: "Select a discount code",
                                    options: discountCodeOptions.value
                                  }, null, 8, ["modelValue", "options"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_unref(FormElement), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NeueButton), {
                                type: "secondary",
                                onClick: _cache[16] || (_cache[16] = $event => (showPreview.value = true))
                              }, {
                                default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                  _createTextVNode("Preview", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_unref(FormElement), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(InputArea), {
                                modelValue: modal.value.text,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => ((modal.value.text) = $event)),
                                name: "Text",
                                placeholder: "Enter the text for your banner"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormElement), null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_11, _toDisplayString(modal.value.text || 'Banner preview'), 1)
                            ]),
                            _: 1
                          })
                        ], 64))
                  ], 64))
                : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(NeueButton), {
          type: "secondary",
          onClick: _cache[18] || (_cache[18] = $event => (modal.value = { open: false }))
        }, {
          default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(NeueButton), {
          type: "primary",
          disabled: !canSaveModal.value,
          onClick: saveAnnouncement
        }, {
          default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
            _createTextVNode("Save", -1)
          ]))]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["is-open", "modal-title"]),
    _createVNode(_unref(TheModal), {
      "is-open": showPreview.value,
      "modal-title": "Popup preview",
      onCloseModal: _cache[21] || (_cache[21] = $event => (showPreview.value = false))
    }, {
      main: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_unref(PopupCard), {
            headline: modal.value.headline,
            text: modal.value.text,
            "image-url": modal.value.images?.[0]?.attributes?.secure_url ?? null,
            "collect-from-customer": modal.value.collectFromCustomer,
            "give-reward": modal.value.giveReward,
            audience: modal.value.audience
          }, null, 8, ["headline", "text", "image-url", "collect-from-customer", "give-reward", "audience"])
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(NeueButton), {
          type: "secondary",
          onClick: _cache[20] || (_cache[20] = $event => (showPreview.value = false))
        }, {
          default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
            _createTextVNode("Close", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open"])
  ], 64))
}
}

}